const isDevelopment = process.env.NODE_ENV === 'development'

// API URL will be automatically selected based on the environment
// In development: Uses .env.development (localhost)
// In production: Uses .env.production (production URL)
export const API_URL = process.env.REACT_APP_API_URL || (isDevelopment ? 'http://localhost:8080/api' : 'https://chrysalis-backend.onrender.com/api')
